export const accordionSx = (theme) => ({
  backgroundColor: theme.palette.secondary.main,
  border: `solid 1px ${theme.palette.primary.main}`,
  marginTop: '24px',
});
